import {
  PartnerFinanceMonthBillIncome,
  PartnerFinanceMonthRewardIncome,
} from 'types/partnerFinance';
import { createUniqueRuntimeNumber } from './uniqueRuntimeNumberUtils';

export function createPartnerFinanceMonthBillIncome(): PartnerFinanceMonthBillIncome {
  return {
    type: 'BILL_INCOME',
    clientId: 0,
    amount: 0,
    dateISO: '',
    organization: '',
    periodEndDateISO: '',
    periodStartDateISO: '',
  };
}

export function createPartnerFinanceMonthBillIncomeMock(): PartnerFinanceMonthBillIncome {
  return {
    type: 'BILL_INCOME',
    clientId: createUniqueRuntimeNumber(),
    amount: 12,
    dateISO: new Date().toISOString(),
    organization: 'ООО Компания',
    periodEndDateISO: new Date().toISOString(),
    periodStartDateISO: new Date().toISOString(),
  };
}

export function createPartnerFinanceMonthRewardIncome(): PartnerFinanceMonthRewardIncome {
  return {
    id: 0,
    type: 'REWARD_INCOME',
    amount: 0,
    dateISO: '',
    comment: '',
  };
}

export function createPartnerFinanceMonthRewardIncomeMock(): PartnerFinanceMonthRewardIncome {
  return {
    id: createUniqueRuntimeNumber(),
    type: 'REWARD_INCOME',
    amount: 1300,
    dateISO: new Date().toISOString(),
    comment:
      'Так держать! Вот тебе длинный коммент и немного денег. Недостаточно длинный? Вот тебе еще длиннее!',
  };
}
